/**
 * Query keys of the futures reads — a module without `'use client'`, so the
 * server render builds the same key the hook reads.
 */

/** Distinct from the trade zone's `pairs-list` key — the shapes differ and the QueryClient is shared. */
export const FUTURES_PAIRS_QK = ['futures-pairs-meta'] as const;
export const LAST_DAY_TICKERS_QK = ['futures-last-day-tickers'] as const;

export function dayClosesKey(pairId: number) {
  return ['futures-day-closes', pairId] as const;
}
